
import { IGlobalState } from "@/store";
import { IApplication } from "@/typings/application";
import { useStore } from "vuex";
import { defineComponent, PropType, reactive, toRefs } from "vue";

export default defineComponent({
  props: {
    application: {
      type: Object as PropType<IApplication>,
      default: null,
    },
  },
  setup() {
    const store = useStore<IGlobalState>();
    const state = reactive({
      aliyunPath:store.state.app.aliyunPath + "/"
    });
    return {
      ...toRefs(state)
    };
  },
});
